import { extractAccountLast4 } from "@/shared/utils/accountNumber";
import { resolveBalance } from "@/shared/utils/balanceEstimates";

import type { CreateEstateItemRequest } from "@/shared/types/estateTypes";

export interface CreditCardManualForm {
  institution: string;
  accountLast4: string;
  balance: string;
  unknownBalance: boolean;
  estimateRange: string;
  statementFile: File | null;
}

export const EMPTY_CREDIT_CARD_FORM: CreditCardManualForm = {
  institution: "",
  accountLast4: "",
  balance: "",
  unknownBalance: false,
  estimateRange: "",
  statementFile: null,
};

// Only the last 4 digits are persisted (the financials edge function copies
// metadata.account_last4 into identifiers). The full card number is never stored.
export function buildManualCreditCardItem(
  form: CreditCardManualForm,
  estateId: number,
  sourceDocumentId?: number,
): CreateEstateItemRequest {
  const institution = form.institution.trim();
  const accountLast4 = extractAccountLast4(form.accountLast4);

  return {
    estate_id: estateId,
    category: "Unsecured Debts",
    classification: "debt",
    item_name: institution,
    balance: resolveBalance(form.unknownBalance, form.estimateRange, form.balance),
    is_estimated: form.unknownBalance,
    balance_estimate_range: form.unknownBalance ? form.estimateRange || "unsure" : null,
    metadata: { institution, ...(accountLast4 ? { account_last4: accountLast4 } : {}) },
    source_document_id: sourceDocumentId,
  };
}
